import React, {
  createContext,
  useState,
  useEffect,
  useCallback,
} from 'react'
import {
  getAccessToken,
  getRefreshToken,
  getStoredUser,
  setTokens,
  clearTokens,
} from '../utils/storage'
import { getCurrentUser, refreshTokens } from '../api/auth.api'

const AuthContext = createContext(null)

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const login = useCallback((accessToken, refreshToken) => {
    setTokens(accessToken, refreshToken)
    const decoded = getStoredUser()
    setUser(decoded)
    setIsAuthenticated(true)
  }, [])

  const logout = useCallback(() => {
    clearTokens()
    setUser(null)
    setIsAuthenticated(false)
    window.location.assign('/')
  }, [])

  const checkAuth = useCallback(async () => {
    try {
      const response = await getCurrentUser()
      setUser({ ...(response.user ?? {}), cliente: response.cliente ?? null })
      setIsAuthenticated(true)
    } catch {
      const refreshToken = getRefreshToken()
      if (!refreshToken) {
        logout()
        return
      }

      try {
        const response = await refreshTokens(refreshToken)
        const { accessToken, refreshToken: newRefreshToken } = response

        setTokens(accessToken, newRefreshToken)
        const decoded = getStoredUser()
        setUser(decoded)
        setIsAuthenticated(true)
      } catch {
        logout()
      }
    }
  }, [logout])

  useEffect(() => {
    const init = async () => {
      const token = getAccessToken()

      if (token) {
        const decoded = getStoredUser()
        setUser(decoded)
        setIsAuthenticated(true)
        await checkAuth()
      }

      setIsLoading(false)
    }

    init()
  }, [checkAuth])

  const value = {
    user,
    isAuthenticated,
    isLoading,
    login,
    logout,
    checkAuth,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export default AuthContext
